import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import initCy, {
  bindDocumentEvent,
  correctTreeData,
  initView,
  selectNode,
} from './scripts/cy-core';
import { cleanUpState, setCurrentNode, setImages } from './scripts/tree-slice';
import TreeHeader from './TreeHeader';
import TreeBody from './TreeBody';
// import 'bootstrap/dist/css/bootstrap.css';
import './css/cy.css';
// import './css/style.css';
// import './css/app.css';
// import './css/bootstrap-table.css';
import { COMPOUND_BACKGROUND, COMPOUND_CONTENT, defaultZoom } from './scripts/cy-constant';
import GoogleOneTapLogin from './GoogleOneTapLogin';

const FamilyTree = () => {
  const dispatch = useDispatch();
  const treeData = useSelector((state) => state.tree.treeData);
  const currentNode = useSelector((state) => state.tree.currentNode);
  const user = useSelector((state) => state.auth.user);

  let [cy, setCy] = useState(null);

  const [isMaxZoomLimited, setIsMaxZoomLimited] = useState(false);

  const bindCyEvent = () => {
    cy.on('tap', (evt) => {
      const { target } = evt;
      // // debug-console.log( node);

      let tappedEleId;
      if (target === cy) {
        // // debug-console.log('tap on background');
        tappedEleId = '';
        if (
          $('#graphControlPanel').css('top') === '-150px' &&
          $('#graphControlPanel').css('display') !== 'none'
        ) {
          $('#graphControlPanel').hide();
        }
      } else {
        // // debug-console.log('tap on some element');
        tappedEleId = target.id();
        if (
          tappedEleId &&
          tappedEleId !== COMPOUND_BACKGROUND &&
          tappedEleId !== COMPOUND_CONTENT
        ) {
          let tappedEle = cy.getElementById(tappedEleId);
          if (tappedEle.isEdge()) {
            tappedEle = tappedEle.target(); // if edge is tapped-> select target Node
            tappedEleId = tappedEle.id();
          }

          if ($('#graphControlPanel').css('display') === 'none') {
            $('#graphControlPanel').show();
          }

          if (tappedEleId !== currentNode?.id) {
            const newCurrentNode = tappedEle.jsons();
            // debug-console.log('tap on new node: ', tappedEleId, tappedEle.data('name'));
            if (newCurrentNode?.length > 0) {
              dispatch(setCurrentNode(newCurrentNode[0].data));
            }
          } else {
            // debug-console.log('tap on currentNode: ', tappedEleId, currentNode);
            // only select node for light weight
            selectNode(tappedEleId, true, false);
          }
        }
      }

      if (evt.ctrlKey) {
        // debug-console.log('CTRL is on');
      }
    });

    bindCyZoomEvent();
  };

  const bindCyZoomEvent = () => {
    cy.on('scrollzoom', () => {
      // run after 'zoom'
      // currently not zoomed yet, just have new value
      if (cy.zoom() === cy.maxZoom()) {
        if (!isMaxZoomLimited) {
          // skip first time
          setIsMaxZoomLimited(true);
          // autoScrollTop = true;
        } else {
          cy.zoom(defaultZoom);
          onBtnFocus();
        }
      } else {
        setIsMaxZoomLimited(false);
        // autoScrollTop = false;
      }
      // // debug-console.log('scroll zoom = ', cy.zoom(), evt);
    }); // hen the viewport is zoomed via the scroll wheel

    cy.on('zoom', () => {
      // // debug-console.log('cy.zoom= ', zoomLevel, evt);
      $('#zoomLevel').text(Math.round(cy.zoom() * 4) / 4);
    });
  };

  useEffect(() => {
    // debug-console.log('[Use Effect] treeData changed');
    if (!treeData) return;
    // need to use treeData.data only, will remove the second later
    const cyData = correctTreeData(treeData);

    const imgArray = Array.from(cyData)
      .map((ele) => ele?.data.img)
      .filter((e) => e != null && e.trim().length > 0);

    const images = new Set(imgArray);
    // debug-console.log('familyTree: images:' + images.size, images);

    dispatch(setImages(Array.from(images)));
    cy = initCy(cyData);

    setCy(cy);

    bindCyEvent();
    initView();
    bindDocumentEvent();
    // select first node
    let selectedNode = cy.nodes(':selected').first();
    // debug-console.log('familyTree: selectedNode=', cy.nodes(':selected'), selectedNode);

    if (!selectedNode) {
      selectedNode = cy.nodes().first();
    }
    if (selectedNode && !currentNode.id) {
      const newCurrentNode = selectedNode.jsons();
      // debug-console.log('familyTree: new currentNode=', newCurrentNode);
      if (newCurrentNode?.length > 0) {
        // init for first time load treeData only:
        dispatch(setCurrentNode(newCurrentNode[0].data));
      } else {
        dispatch(cleanUpState());
      }
    }
  }, [treeData]);

  return (
    <div id="body">
      {!user && <GoogleOneTapLogin />}
      <TreeHeader cy={cy} />
      <TreeBody cy={cy} />
    </div>
  );
};

export default FamilyTree;
